(() => {
  const desktop = window.matchMedia('(min-width: 768px)');

  function loadHoverImage(target) {
    if (!desktop.matches) return;

    const wrapper = target.closest('.product-card')?.querySelector('.product-card__image-wrapper');
    const image = wrapper?.querySelector('.product-card__image--second img[data-src]');
    if (!image) return;

    image.addEventListener('load', () => wrapper.classList.add('second-image-ready'), { once: true });
    image.addEventListener('error', () => wrapper.classList.add('second-image-error'), { once: true });

    if (image.dataset.srcset) {
      image.srcset = image.dataset.srcset;
      image.removeAttribute('data-srcset');
    }
    image.src = image.dataset.src;
    image.removeAttribute('data-src');
  }

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
      loadHoverImage(event.target);
    }
  });
  document.addEventListener('focusin', (event) => loadHoverImage(event.target));
})();
